import { render, staticRenderFns } from "./CardInteligenciaTerritorialPotencialAgropecuarioVegetacaoImovel.vue?vue&type=template&id=62e88396&scoped=true&lang=pug"
import script from "./CardInteligenciaTerritorialPotencialAgropecuarioVegetacaoImovel.vue?vue&type=script&lang=js"
export * from "./CardInteligenciaTerritorialPotencialAgropecuarioVegetacaoImovel.vue?vue&type=script&lang=js"
import style0 from "./CardInteligenciaTerritorialPotencialAgropecuarioVegetacaoImovel.vue?vue&type=style&index=0&id=62e88396&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e88396",
  null
  
)

export default component.exports